import { useEffect, useState } from "react";
import "./TermsAndConditions.scss"; 
import { useTranslation } from "react-i18next";
import { getTermsAndConditions } from "../../../common/api/apiCalls";

const TermsAndConditions = () => {
    const { t } = useTranslation();
    const [termsHtml, setTermsHtml] = useState<string>("");

    useEffect(() => {
        async function fetchTerms() {
            try {
                const response = await getTermsAndConditions();
                console.log("Fetched Terms:", response);
                if (response?.success && response.data) {
                    setTermsHtml(response.data); 
                }
            } catch (error) {
                console.error("Error fetching Terms and Conditions:", error);
            }
        }
        fetchTerms();
    }, []);

    return (
        <div className="terms-main-container flex-center">
            {termsHtml ? (
                <div className="terms-container" dangerouslySetInnerHTML={{ __html: termsHtml }} />
            ) : (
                <p>{t("Loading...")}</p>
            )}
        </div>
    );
};

export default TermsAndConditions;
